import {Component, Input, OnInit} from '@angular/core';
import {LokijsService} from '../../services/database/lokijs.service';
import {OperatorModel} from '../../models/operator.model';
import {DocumentModel} from '../../models/document.model';
import {DummyOperators} from '../../definitions/dummy-operators';

@Component({
    selector: 'select-queue-operator',
    templateUrl: './select-queue-operator.component.html',
    styleUrls: ['./select-queue-operator.component.scss'],
})
export class SelectQueueOperatorComponent implements OnInit {

    @Input() document: DocumentModel;
    operatorsList: OperatorModel[] = [];

    constructor(private loki: LokijsService,
                private dummy: DummyOperators) {
    }

    ngOnInit() {
        const tempList = this.loki.getCollection('operator').chain().simplesort('username').data();
        console.log(this.dummy.populateDummyOperators());
        const dummyOp = this.dummy.populateDummyOperators();
        for (const op of dummyOp) {
            this.operatorsList.push(op);
        }
        for (const op of tempList) {
            this.operatorsList.push(op);
        }

    }

    setOperator(event: any) {
        this.document.queuedToOperatorId = event;
    }
}
